import { fetchAuthSession } from 'aws-amplify/auth';

export const scraperService = {
  apiUrl: `${process.env.REACT_APP_API_BASE_URL}/scrape-and-summarize`,
  
  scrapeAndSummarize: async (url: string): Promise<string> => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      
      const response = await fetch(scraperService.apiUrl, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` })
        },
        body: JSON.stringify({ url })
      });

      if (!response.ok) {
        throw new Error(`Scraping and summarization failed: ${response.status}`);
      }

      const result = await response.json();
      return result.summary;
    } catch (error) {
      console.error('Scraping and summarization error:', error);
      throw error;
    }
  }
};